<style lang="less">
.content-view {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;

  p {
    padding: 15px;
    text-align: left;
    font-size: 15pt;
  }

  h2 {
    text-align: center;
    font-size: 18pt;
  }

  div {
    background: white;
    padding: 20px;
  }
}
</style>

<template>
  <div class="content-view ">
    
  </div>
</template>

<script>
import lodash from "lodash";
import moment from "moment";
import { Alert } from "vue-ydui/dist/lib.rem/dialog";
import qs from "querystring";

const assets = {
  scan1: require("../assets/wxscan.png"),
  scan2: require("../assets/wxscan2.png")
};

export default {
  name: "login",

  components: {
  },

  data: () => ({
    assets,
    order: {},
    displayShpping: false,
    shippingStatus: false,
    showPayDialog: false,
    displayChangeComment: false,
    codeUrl: ""
  }),

  computed: {
    // displayShpping() {
    //   console.log("shippingStatus", this.shippingStatus);
    //   return this.shippingStatus && this.shippingStatus.status == 200;
    // },
    orderItems() {
      return this.order ? this.order.items : [];
    },
    payDict() {
      return {
        PAID: "已支付",
        UNPAID: "未支付"
      };
    },
    goodsDict() {
      return {
        UNSHIPPED: "未发货",
        SHIPPED: "已发货"
      };
    },
   
    orderStep() {
      if (this.shipped) {
        return 4;
      }
      if (this.paid) {
        return 3;
      }
      return 2;
    },
    cancelEnabled() {
      const order = this.order;
      return order.status == "NORMAL" && order.goods_status != "SHIPPED";
    },
    payEanbled() {
      const order = this.order;
      return order.pay_status == "UNPAID" && order.status == "NORMAL";
    },
    created() {
      
    },
  },

  methods: {
    errorBack() {
    
      this.$dialog.alert({
        mes: "错误的访问方式",
        callback: () => this.$router.replace({ name: "home" })
      });
    },

    async logout() {
      localStorage.setItem("auth", "")
      location.reload()
    },
  },

  async mounted() {
      var query = qs.parse(location.search.replace("?", ""));

      if (location.href.indexOf("localhost:8080") > -1) {
        var token = window.prompt("输入token")
        localStorage.setItem("auth", token)
        location.href = "/"
        return
      }
      if (!query.code) {
        var returl = window.location.protocol+"//"+ window.location.host+"/login"

        location.href = "/api/auth?auth_url="+encodeURIComponent(returl)
        return
      } else {
        const resp = await this.$store.dispatch(
          "auth/init",
          {
            code: query.code
          }
        );
        location.href = "/"
      }
  }
};
</script>
